import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import dayjs, {Dayjs} from 'dayjs';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {messageBoxError} from '@deviceinsight/ng-ui-components';
import {BLINKING_FREQUENCY} from '../../../modules/ruleengine/config/consts';
import {syncLed} from '../../../api/directMethodActionsApi';
import {displayConfirmMessage} from '../../../api/apiUtils';

const processDirectMethodResponse = (response: any, invocationTime: Dayjs): void => {
	let displayMessage = `${response.message ? ' ' + response.message : ''}`;

	switch (response.status) {
		case 200:
		case 201:
		case 204:
			displayMessage = `Device responded in ${dayjs().diff(invocationTime)} ms`;
			break;
	}

	displayConfirmMessage(
		<div>
			<Trans i18nKey="dashboard.widgets.digitaltwin.directmethodmessage">Direct Message Info:</Trans>
			{displayMessage}
		</div>
	);
};

const processDirectMethodError = (error: any): void => {
	const {
		response: {status, data}
	} = error;
	let displayMessage = `Action was unsuccessful.`;

	switch (status) {
		case 422:
			try {
				// Parsing direct method invocation message from IoT Hub
				const errorContent = JSON.parse(data.message);
				displayMessage = `${errorContent.message} (${errorContent.errorCode})`;
			} catch (e) {
				// data.message is not a JSON object
				displayMessage = data ? data : error.message;
			}

			break;

		default:
			displayMessage += ' ' + error.message;
	}

	messageBoxError(
		<div>
			<Trans i18nKey="dashboard.widgets.digitaltwin.directmethoderror">Direct Message Error:</Trans>
			{displayMessage}
		</div>,
		undefined,
		'DeviceAction'
	);
};

const directMethodCall = (
	asset: Asset,
	dataPoint: string,
	color: string | null | undefined,
	isBlink: boolean
): void => {
	const invocationTime = dayjs();
	syncLed(asset, dataPoint, color, isBlink ? BLINKING_FREQUENCY : 0)
		.then((response) => processDirectMethodResponse(response, invocationTime))
		.catch((response) => processDirectMethodError(response));
};

export default directMethodCall;
